import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../styles/Privacy.css';

export class Privacy extends Component {


    render() {
        return (
            <Container fluid>
                <Row><Col><h1>Privacy Policy</h1></Col></Row>
                <Row><Col><h4>Introduction</h4></Col></Row>
                <Row><Col><div>
                    <p>We recognize that the privacy of your personal information is important. The purpose of this policy is to let you know how we handle the information collected through the use of this website. Portions of this website may describe privacy practices applicable to specific types of information or to information provided on specific web pages</p>
                    <p>This policy does not apply to information collected through other means such as by telephone or in person, although that information may be protected by other privacy policies. As used in this policy, terms such as "we", "us", "our", and "Company" refer to Optum and its current and future affiliated entities, including our parent company UnitedHealth Group.</p>
                    <p>This website is intended for a United States audience. Any information you provide, including any personal information, will be transferred to and processed by a computer server located within the United States.</p>
                </div></Col></Row>

                <Row><Col><h4>Your Personal Information</h4></Col></Row>
                <Row><Col><div>
                    <p>
                        This website may include web pages that give you the opportunity to provide us with personal information about yourself. You do not have to provide us with personal information if you do not want to; however, that may limit your ability to use certain functions of this website or to request certain services or information.</p>
                    <p>We may use personal information for a number of purposes such as:</p>
                    <ul>
                        <li>To respond to an email or particular request from you.</li>
                        <li>To personalize the website for you.</li>
                        <li>To process an application as requested by you.</li>
                        <li>To administer surveys and promotions.</li>
                        <li>To provide you with information that we believe may be useful to you, such as information about health products or services provided by us or other businesses.</li>
                        <li>To perform analytics and to improve our products, websites, and advertising.</li>
                        <li>To comply with applicable laws, regulations, and legal process.</li>
                        <li>To protect someone's health, safety, or welfare.</li>
                        <li>To protect our rights, the rights of affiliates or related third parties, or take appropriate legal action, such as to enforce our Terms of Use.</li>
                        <li>To keep a record of our transactions and communications.</li>
                        <li>As otherwise necessary or useful for us to conduct our business, so long as such use is permitted by law.</li>
                    </ul>
                </div></Col></Row>
            </Container>
        );
    }
}